import React from 'react';
import { View, Text, StyleSheet, Image, TouchableOpacity, ScrollView, Dimensions, SafeAreaView, StatusBar, Platform } from 'react-native';
import { useNavigation, useRoute } from '@react-navigation/native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import PlatformDetector from '../../utils/PlatformDetector';

const PromocionDetalle = () => {
  // Obtener la altura del StatusBar para dispositivos móviles
  const statusBarHeight = StatusBar.currentHeight || 0;
  
  // Calcular el margen superior basado en la plataforma
  const topMargin = PlatformDetector.select({
    web: 0,
    android: statusBarHeight > 0 ? statusBarHeight : 30, // Valor de respaldo si statusBarHeight es 0
    ios: 50, // iOS generalmente necesita más espacio para el notch
    default: 0
  });
  const navigation = useNavigation();
  const route = useRoute();
  const { promo } = route.params || { promo: null };

  if (!promo) {
    return (
      <SafeAreaView style={[styles.container, PlatformDetector.isMobile() && { paddingTop: topMargin }]}>
        <Text style={styles.errorText}>No se encontró información de la promoción</Text>
        <TouchableOpacity style={styles.backButton} onPress={() => navigation.navigate('Home')}>
          <Text style={styles.backButtonText}>Volver al inicio</Text>
        </TouchableOpacity>
      </SafeAreaView>
    );
  }

  return (
    <SafeAreaView style={[styles.container, PlatformDetector.isMobile() && { paddingTop: topMargin }]}>
      <View style={styles.header}>
        <TouchableOpacity style={styles.backButton} onPress={() => navigation.goBack()}>
          <MaterialCommunityIcons name="arrow-left" size={24} color="#fff" />
          <Text style={styles.backButtonText}>Volver</Text>
        </TouchableOpacity>
        <Text style={styles.headerTitle}>{promo.banco}</Text>
        <View style={styles.headerRight} />
      </View>

      <ScrollView style={styles.scrollView} showsVerticalScrollIndicator={false}>
        <View style={[styles.promoHeader, { backgroundColor: promo.color }]}>
          <View style={styles.discountCircle}>
            <Text style={styles.discountText}>{promo.descuento}</Text>
            <Text style={styles.discountLabel}>DE DESCUENTO</Text>
          </View>
          
          <View style={styles.daysContainer}>
            <MaterialCommunityIcons name="calendar-check" size={24} color="#fff" />
            <Text style={styles.daysText}>{promo.dias}</Text>
          </View>
        </View>

        <View style={styles.promoDetails}>
          <View style={styles.promoTitleContainer}>
            <Text style={styles.promoTitle}>Promoción {promo.banco}</Text>
            <View style={styles.badgeContainer}>
              <Text style={styles.badgeText}>Exclusivo</Text>
            </View>
          </View>
          
          <View style={styles.divider} />
          
          <View style={styles.infoSection}>
            <View style={styles.infoHeader}>
              <MaterialCommunityIcons name="information-outline" size={22} color="#333" />
              <Text style={styles.sectionTitle}>Detalles de la promoción</Text>
            </View>
            <Text style={styles.promoDescription}>
              Obtén un <Text style={styles.highlightText}>{promo.descuento}</Text> de descuento en todas tus compras pagando con tarjetas {promo.banco} los días <Text style={styles.highlightText}>{promo.dias.toLowerCase()}</Text>.
            </Text>
          </View>
          
          <View style={styles.termsContainer}>
            <View style={styles.termsHeader}>
              <MaterialCommunityIcons name="file-document-outline" size={22} color="#333" />
              <Text style={styles.termsTitle}>Términos y condiciones</Text>
            </View>
            <View style={styles.termsList}>
              <View style={styles.termItem}>
                <View style={styles.bulletPoint} />
                <Text style={styles.termsText}>Promoción válida únicamente los días {promo.dias.toLowerCase()}.</Text>
              </View>
              <View style={styles.termItem}>
                <View style={styles.bulletPoint} />
                <Text style={styles.termsText}>El descuento se aplica directamente en el pago.</Text>
              </View>
              <View style={styles.termItem}>
                <View style={styles.bulletPoint} />
                <Text style={styles.termsText}>No acumulable con otras promociones.</Text>
              </View>
              <View style={styles.termItem}>
                <View style={styles.bulletPoint} />
                <Text style={styles.termsText}>Válido para tarjetas de débito y crédito {promo.banco}.</Text>
              </View>
              <View style={styles.termItem}>
                <View style={styles.bulletPoint} />
                <Text style={styles.termsText}>Promoción sujeta a cambios sin previo aviso.</Text>
              </View>
            </View>
          </View>
          
          <TouchableOpacity style={styles.usePromoButton} activeOpacity={0.8}>
            <MaterialCommunityIcons name="credit-card-outline" size={20} color="#fff" style={styles.buttonIcon} />
            <Text style={styles.usePromoButtonText}>Usar esta promoción</Text>
          </TouchableOpacity>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};

const { width: screenWidth } = Dimensions.get('window');

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f8f8f8',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#333',
    paddingVertical: 15,
    paddingHorizontal: 15,
    ...(Platform.OS === 'web'
      ? { boxShadow: '0 2px 6px rgba(0,0,0,0.2)' }
      : {
          elevation: 4,
          shadowColor: '#000',
          shadowOffset: { width: 0, height: 2 },
          shadowOpacity: 0.2,
          shadowRadius: 2,
        }
    ),
  },
  headerTitle: {
    color: '#fff',
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  headerRight: {
    width: 30, // Para mantener el título centrado
  },
  backButton: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  backButtonText: {
    marginLeft: 5,
    fontSize: 16,
    color: '#fff',
  },
  scrollView: {
    flex: 1,
  },
  errorText: {
    fontSize: 16,
    textAlign: 'center',
    marginTop: 20,
    padding: 20,
  },
  promoHeader: {
    padding: 30,
    alignItems: 'center',
    justifyContent: 'center',
    height: 220,
  },
  discountCircle: {
    width: 120,
    height: 120,
    borderRadius: 60,
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 20,
    ...(Platform.OS === 'web'
      ? { boxShadow: '0 3px 8px rgba(0,0,0,0.3)' }
      : {
          shadowColor: '#000',
          shadowOffset: { width: 0, height: 3 },
          shadowOpacity: 0.3,
          shadowRadius: 4,
          elevation: 5,
        }
    ),
  },
  discountText: {
    color: '#fff',
    fontSize: 48,
    fontWeight: 'bold',
    textShadow: '1px 1px 2px rgba(0, 0, 0, 0.3)',
  },
  discountLabel: {
    color: '#fff',
    fontSize: 14,
    fontWeight: 'bold',
    textTransform: 'uppercase',
    letterSpacing: 1,
  },
  daysContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    paddingVertical: 8,
    paddingHorizontal: 15,
    borderRadius: 20,
  },
  daysText: {
    color: '#fff',
    fontSize: 14,
    fontWeight: '600',
    marginLeft: 8,
  },
  promoDetails: {
    backgroundColor: '#fff',
    borderTopLeftRadius: 25,
    borderTopRightRadius: 25,
    marginTop: -25,
    padding: 25,
    paddingBottom: 40,
    minHeight: 400,
  },
  promoTitleContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 5,
  },
  promoTitle: {
    fontSize: 22,
    fontWeight: 'bold',
    color: '#333',
    flex: 1,
  },
  badgeContainer: {
    backgroundColor: '#ff0000',
    paddingVertical: 4,
    paddingHorizontal: 10,
    borderRadius: 12,
  },
  badgeText: {
    color: '#fff',
    fontSize: 12,
    fontWeight: 'bold',
  },
  divider: {
    height: 1,
    backgroundColor: '#e0e0e0',
    marginVertical: 20,
    width: '100%',
  },
  infoSection: {
    marginBottom: 25,
  },
  infoHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    marginLeft: 8,
    color: '#333',
  },
  promoDescription: {
    fontSize: 16,
    lineHeight: 24,
    color: '#444',
    paddingHorizontal: 5,
  },
  highlightText: {
    fontWeight: 'bold',
    color: '#ff0000',
  },
  termsContainer: {
    backgroundColor: '#f9f9f9',
    padding: 20,
    borderRadius: 12,
    marginBottom: 25,
    borderWidth: 1,
    borderColor: '#eee',
  },
  termsHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 15,
  },
  termsTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginLeft: 8,
    color: '#333',
  },
  termsList: {
    paddingLeft: 5,
  },
  termItem: {
    flexDirection: 'row',
    marginBottom: 8,
    alignItems: 'flex-start',
  },
  bulletPoint: {
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: '#ff0000',
    marginTop: 7,
    marginRight: 10,
  },
  termsText: {
    fontSize: 14,
    color: '#555',
    flex: 1,
    lineHeight: 20,
  },
  usePromoButton: {
    backgroundColor: '#ff0000',
    paddingVertical: 15,
    borderRadius: 10,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 10,
    ...(Platform.OS === 'web'
      ? { boxShadow: '0 3px 10px rgba(255,0,0,0.3)' }
      : {
          shadowColor: '#ff0000',
          shadowOffset: { width: 0, height: 3 },
          shadowOpacity: 0.3,
          shadowRadius: 5,
          elevation: 5,
        }
    ),
  },
  buttonIcon: {
    marginRight: 10,
  },
  usePromoButtonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
  },
});

export default PromocionDetalle;
